var editorGlobalAttributes = require("../dashboard/pages/platform.editor-global-attributes.js");
var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "class.tokens",
    title: "Curated CSS Class Tokens",
    description: "Validates a space-separated string or array of curated CSS class selections, including bundled multi-class presets.",
    type: "field",
    use: {
        namespace: "ua.input"
    },
    tests: {
        validAtomicString: {
            must: true,
            run: function () {
                return validate({ options: ["container", "py-4"] }, "container py-4");
            }
        },
        validBundledString: {
            must: true,
            run: function () {
                return validate({ options: ["bg-body", "bg-dark text-white"] }, "bg-dark text-white");
            }
        },
        validBundledArray: {
            must: true,
            run: function () {
                return validate({ options: ["container", "bg-dark text-white"] }, ["container", "bg-dark text-white"]);
            }
        },
        invalidBundledAtomicSplit: {
            throw: "fields.class.tokens.invalidOption",
            run: function () {
                return validate({ options: ["bg-dark text-white"] }, "bg-dark text-muted");
            }
        }
    },
    errors: {
        invalidOption: {
            title: "Unsupported Class Token",
            description: "The class token or bundled preset is not in the curated allowlist for this field.",
            template: "Unsupported class token: ${value}"
        },
        missingOptions: {
            title: "Missing Curated Options",
            description: "class.tokens fields require an options list in the schema.",
            template: "class.tokens requires schema options to validate ${value}"
        }
    }
});

function normalizeClassName(value) {
    return editorGlobalAttributes.normalizeClassName(value);
}

function normalizeOptions(options) {
    var list = options instanceof Array ? options : [];
    return list.map(function(option) {
        if (typeof option === "string") return normalizeClassName(option);
        if (option && typeof option === "object") return normalizeClassName(option.value || "");
        return "";
    }).filter(Boolean);
}

function withOptionSet(options, run) {
    var optionSetName = "__classTokensValidation";
    var previous = editorGlobalAttributes.CLASS_TOKEN_SETS[optionSetName];
    editorGlobalAttributes.CLASS_TOKEN_SETS[optionSetName] = {
        options: normalizeOptions(options).map(function(option) {
            return { value: option };
        }),
        exclusiveGroups: []
    };
    try {
        return run(optionSetName);
    } finally {
        if (previous) editorGlobalAttributes.CLASS_TOKEN_SETS[optionSetName] = previous;
        else delete editorGlobalAttributes.CLASS_TOKEN_SETS[optionSetName];
    }
}

function normalizeInput(value) {
    if (Array.isArray(value)) {
        return normalizeClassName(value.map(function(item) {
            return normalizeClassName(item);
        }).filter(Boolean).join(" "));
    }
    return normalizeClassName(value);
}

function validate(spec, value) {
    if (!(typeof value === "string" || Array.isArray(value))) _.errors.invalidOption.throw({ value: value });
    var options = normalizeOptions(spec && spec.options);
    if (!(options.length)) _.errors.missingOptions.throw({ value: value });
    var normalizedInput = normalizeInput(value);
    var sanitized = withOptionSet(options, function(optionSetName) {
        return editorGlobalAttributes.sanitizeClassTokens(value, optionSetName);
    });
    if (sanitized !== normalizedInput) _.errors.invalidOption.throw({ value: normalizedInput || value });
}
module.exports.validate = validate;
